import { ReactNode } from 'react';
import { Popover } from '@c2fo/liquidity';
import { InfoCircleIcon } from '@c2fo/liquidity/icons';

export interface OfferConfigDetailsItem {
  label: string;
  value: ReactNode;
  tooltip?: ReactNode;
}

export const OfferConfigDetails = ({ items }: { items: OfferConfigDetailsItem[] }) => {
  if (!items.length) {
    return null;
  }

  return (
    <div className="w-full divide-y divide-black divide-opacity-30 rounded-md bg-canvas">
      {items.map((item) => (
        <div key={item.label} className="flex items-center justify-between gap-4 p-4">
          <div>{item.label}</div>
          <div className="flex gap-1 text-right font-semibold">
            {item.tooltip && (
              <Popover>
                <Popover.Trigger>
                  <InfoCircleIcon className="h-4 w-4 fill-primary-500" />
                </Popover.Trigger>
                <Popover.Content arrow className="w-52 text-center text-sm" side="top">
                  {item.tooltip}
                </Popover.Content>
              </Popover>
            )}
            {item.value}
          </div>
        </div>
      ))}
    </div>
  );
};
